import { type Conversation } from "shared/apiClient";

import { getText } from "shared/lib";

import { BAY } from "./BAY";
import { BOR } from "./BOR";
import { EG } from "./EG";
import { GB } from "./GB";
import { Fallback } from "./Fallback";
import { MELT } from "./MELT";
import { MP } from "./MP";
import { MV } from "./MV";
import { SSC } from "./SSC";
import { YRC } from "./YRC";

export interface NextStepItemsProps {
  assessmentLights: string;
  conversation: Conversation | undefined | null;
  isSubdivision?: boolean;
}

export function NextStepItems({
  assessmentLights,
  conversation,
  isSubdivision,
}: NextStepItemsProps) {
  const renderNextStepItems = () => {
    switch (conversation?.council_code?.toUpperCase()) {
      case "BAY":
        return (
          <BAY
            assessmentLights={assessmentLights}
            conversation={conversation}
          />
        );
      case "BOR":
        return (
          <BOR
            assessmentLights={assessmentLights}
            conversation={conversation}
          />
        );
      case "EG":
        return (
          <EG assessmentLights={assessmentLights} conversation={conversation} />
        );
      case "GB":
        return (
          <GB assessmentLights={assessmentLights} conversation={conversation} />
        );
      case "MELT":
        return (
          <MELT
            assessmentLights={assessmentLights}
            conversation={conversation}
          />
        );
      case "MP":
        return (
          <MP assessmentLights={assessmentLights} conversation={conversation} />
        );
      case "MV":
        return (
          <MV assessmentLights={assessmentLights} conversation={conversation} />
        );
      case "SSC":
        return (
          <SSC
            assessmentLights={assessmentLights}
            conversation={conversation}
          />
        );
      case "YRC":
        return (
          <YRC
            assessmentLights={assessmentLights}
            conversation={conversation}
          />
        );
      default:
        return <Fallback />;
    }
  };

  return (
    <>
      {isSubdivision && (
        <div>
          <h3 className="text-headingmd">
            {getText("Find a licensed land surveyor")}
          </h3>

          <p className="text-bodymd mb-2">
            {getText(
              "A licensed land surveyor is required for parts of the subdivision process. They can also help you navigate the regulations by identifying site constraints and creating compliant plans.",
            )}
          </p>
        </div>
      )}

      {renderNextStepItems()}
    </>
  );
}
